<app-share-button ></app-share-button>
<div class="row">
    <div class="col-md-8 ScrollStyle-1">
<div class="card crd p-3">
    <div class="row">
        <div class="col-md-10 col10 mt-2">
            <h2 >जी-स्टोर </h2>
        </div>
        <div class="col-md-2 col2 "><a href="javascript:void(0)" (click)="openShareOptions()"> <button class="btn share"><img src="./assets/share (5).svg" style="width: 30px;" (click)="menues('share-button')"
            alt=""> </button> </a></div>
        <!-- <div class="col-md-12" (mouseover)="showpayment(true,'1')"
            (mouseout)="showpayment(false,'1')" id='41'>
            <div
                style="max-width: 100%; overflow: hidden; padding-bottom: 56.25%; position: relative;">

                <iframe
                    class="i-frame"
                    src="https://www.youtube.com/embed/RLUj" title="YouTube video player"
                    frameborder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowfullscreen></iframe>
            </div>
        </div> -->
        <div class="col-md-12 mt-2" (mouseover)="showpayment(true,'2')"
            (mouseout)="showpayment(false,'2')" id="42">

            
            <label for="" class="mt-2" >जी-स्टोर, जिसे ई-कॉमर्स स्टोर या ऑनलाइन
                दुकान के रूप में भी जाना जाता है, एक डिजिटल प्लेटफ़ॉर्म है जहां व्यवसाय या
                व्यापारी इंटरनेट पर उत्पाद या सेवाएं बेचते हैं। यह ग्राहकों को भौतिक स्टोर
                पर जाने के बजाय पे जी मोबाइल ऐप का उपयोग करके वस्तुओं या सेवाओं को ब्राउज़
                करने, चयन करने और खरीदने की अनुमति देता है। हम एक असाधारण अवसर साझा करने के
                लिए उत्साहित हैं जो आपके व्यवसाय को ऊपर उठाने और आपकी ऑनलाइन उपस्थिति को
                बढ़ावा देने के लिए डिज़ाइन किया गया है। हमारे पे जी मोबाइल ऐप पर अपनी
                प्रोफ़ाइल बनाकर, आप अपने ऑनलाइन शॉपिंग स्टोर अनुभव को बढ़ाने के लिए तैयार
                किए गए विशेष लाभों और सुविधाओं की दुनिया को अनलॉक करते हैं। हमारे पास 1.5
                करोड़ से अधिक पेशकशों वाली एक उत्पाद लाइब्रेरी है।
            </label>
        </div>
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'3')"
            (mouseout)="showpayment(false,'3')" id="43">

            <h2 >हमारे जी-स्टोर की कुछ विशेषताएं नीचे सूचीबद्ध हैं: </h2>

            <label for="" class="mt-3" ><b>बिज़नेस कार्ड: </b>&nbsp; अपने
                बिज़नेस कार्ड को अपनी डिजिटल पहचान समझें। एक बार जब आप अपनी प्रोफ़ाइल बना
                लेते हैं, तो आपके पास एक अनुकूलन योग्य व्यवसाय कार्ड होगा जो आपके ब्रांड,
                लोगो और आवश्यक व्यावसायिक विवरण प्रदर्शित करता है। यह स्थायी प्रभाव डालने और
                ग्राहकों को यह बताने का एक सशक्त तरीका है कि आप कौन हैं। </label>

            <label for="" class="mt-3" ><b>टिकट:</b>&nbsp; सत्यापित उत्पाद
                मान्यता के पात्र हैं, और यहीं हमारे टिकट आते हैं। इन टिकटों के साथ, आप अपने
                उत्पादों को सत्यापित और भरोसेमंद के रूप में चिह्नित कर सकते हैं। यह आपके
                ग्राहकों के लिए एक संकेत है कि उन्हें किसी विश्वसनीय स्रोत से गुणवत्तापूर्ण
                वस्तुएँ मिल रही हैं। </label>

            <label for="" class="mt-3" ><b>कूपन: </b>&nbsp; अच्छा सौदा किसे
                पसंद नहीं आता? हमारी कूपन सुविधा के साथ, आप अपने ग्राहकों को छूट प्रदान करने
                में सक्षम हैं। यह न केवल अधिक खरीदारी को प्रोत्साहित करता है बल्कि ग्राहक
                निष्ठा भी बनाता है। आकर्षक ऑफर बनाएं और अपनी बिक्री बढ़ते हुए देखें।
            </label>

            <label for="" class="mt-3" ><b>प्रोफ़ाइल क्यूआर कोड:</b>&nbsp;अपने
                ग्राहकों के लिए खरीदारी के अनुभव को सरल बनाएं। प्रत्येक व्यापारी प्रोफ़ाइल
                एक अद्वितीय QR कोड के साथ आती है। जब ग्राहक इस कोड को स्कैन करते हैं, तो वे
                सीधे आपकी प्रोफ़ाइल पर पहुंच जाते हैं, जहां वे आपके उत्पादों का पता लगा सकते
                हैं और आसानी से खरीदारी कर सकते हैं। यह आपके स्टोर को उनकी उंगलियों पर रखने
                जैसा है।

            </label>

            <label for="" class="mt-3" ><b>भुगतान क्यूआर कोड:</b>&nbsp; भुगतान
                को पहले से कहीं अधिक आसान बनाना। एक भुगतान क्यूआर कोड बनाएं जिसे आपके ग्राहक
                अपने लेनदेन को सुरक्षित और तेजी से पूरा करने के लिए स्कैन कर सकें। यह सुविधा
                चेकआउट प्रक्रिया को सुव्यवस्थित करती है, जिससे खरीदारी का सहज अनुभव
                सुनिश्चित होता है।

            </label>

            <label for="" class="mt-3" ><b>24/7 ग्राहक सहायता:</b>&nbsp; क्या
                आपके कोई प्रश्न हैं या सहायता की आवश्यकता है? हमारी समर्पित ग्राहक सहायता
                टीम समय पर समाधान प्रदान करने और एक सहज खरीदारी अनुभव सुनिश्चित करने के लिए
                चौबीसों घंटे उपलब्ध है।

            </label>

            <label for="" class="mt-3" > "आइटम" अनुभाग कार्ट में आइटम जोड़ने के
                लिए तीन विकल्प प्रदान करता है: "जी-स्टोर लाइब्रेरी से उत्पाद जोड़ें," "किसी
                भी उत्पाद को स्कैन करें और अपने कार्ट में जोड़ें," और "आइटम मैन्युअल रूप से
                जोड़ें।" व्यापारियों को अपनी पसंद का कोई भी तरीका चुनने की अनुमति है।
                व्यापारी अपनी प्रोफ़ाइल क्यूआर और स्टोर क्यूआर कोड भी जेनरेट कर सकते हैं।
                जी-स्टोर में बिजनेस कार्ड और स्टैम्प जैसी सुविधाएँ भी उपलब्ध हैं।

            </label>
        </div>
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'4')"
            (mouseout)="showpayment(false,'4')" id="44">
           
            <h2 >
                पे जी के G-Store का उपयोग करने के लाभ:
            </h2>
            <h5 class="mt-3" >ग्राहकों के लिए सुविधा </h5>
            <label for="" class="mt-1" >जी-स्टोर आपके ग्राहकों को किसी भी समय
                कहीं से भी खरीदारी की सुविधा प्रदान करता है, जिससे आपके भौतिक स्टोर पर जाने
                की आवश्यकता समाप्त हो जाती है। यह पहुंच व्यस्त कार्यक्रम वाले व्यक्तियों के
                लिए विशेष रूप से फायदेमंद है।
            </label>

            <h5 class="mt-3" >समय का लचीलापन </h5>
            <label for="" class="mt-1" >आपके पास अपने पसंदीदा शेड्यूल के अनुसार
                अपने जी-स्टोर के संचालन घंटे निर्धारित करने की सुविधा है। इसका मतलब है कि आप
                उस समय को अनुकूलित कर सकते हैं जिसके दौरान आपका ऑनलाइन स्टोर ग्राहकों के लिए
                पहुंच योग्य है। चाहे आप इसे विशिष्ट समय क्षेत्रों के साथ संरेखित करना चाहते
                हों, किसी विशेष लक्षित दर्शकों को पूरा करना चाहते हों, या बस अपनी उपलब्धता
                से मेल खाना चाहते हों, समय अनुसूची निर्धारित करने की क्षमता आपको अपने
                जी-स्टोर के परिचालन घंटों को प्रबंधित और अनुकूलित करने का एक सुविधाजनक तरीका
                प्रदान करती है। आपकी व्यावसायिक आवश्यकताओं और ग्राहकों की अपेक्षाओं को पूरा
                करने के लिए।

            </label>

            <h5 class="mt-3" >प्रभावी लागत </h5>
            <label for="" class="mt-1" >

                ऑनलाइन जी-स्टोर के संचालन में अक्सर भौतिक स्टोरफ्रंट को बनाए रखने की तुलना
                में कम ओवरहेड लागत शामिल होती है। जी-स्टोर किराए, उपयोगिताओं और इन-स्टोर
                कर्मचारियों से संबंधित खर्चों पर बचत कर सकता है।

            </label>

            <h5 class="mt-3" >विविध उत्पाद रेंज </h5>
            <label for="" class="mt-1" >जी-स्टोर व्यवसायों को भौतिक स्थान की
                बाधाओं के बिना उत्पादों की विविध श्रृंखला प्रदर्शित करने का अवसर प्रदान करता
                है। यह विविधता विभिन्न प्राथमिकताओं और आवश्यकताओं वाले ग्राहकों की एक
                विस्तृत श्रृंखला को आकर्षित करती है।
            </label>

            <h5 class="mt-3" >खोज और नेविगेशन में आसानी </h5>
            <label for="" class="mt-1" >जी-स्टोर प्लेटफ़ॉर्म आम तौर पर खोज और
                फ़िल्टर सुविधाएँ प्रदान करते हैं, जिससे आपके ग्राहकों के लिए विशिष्ट उत्पाद
                ढूंढना आसान हो जाता है। यह समग्र खरीदारी अनुभव को बढ़ाता है। </label>

            <h5 class="mt-3" >ग्राहक समीक्षाएं और रेटिंग </h5>
            <label for="" class="mt-1" >जी-स्टोर ग्राहकों को उत्पादों के लिए
                समीक्षा और रेटिंग छोड़ने की अनुमति देता है, जो अन्य खरीदारों के खरीदारी
                निर्णयों को प्रभावित कर सकता है। यह पारदर्शिता ऑनलाइन स्टोर के लिए
                विश्वसनीयता बनाने में मदद करती है। </label>

            <h5 class="mt-3" >कुशल इन्वेंटरी प्रबंधन </h5>
            <label for="" class="mt-1" >जी-स्टोर उन्नत इन्वेंट्री प्रबंधन
                प्रणालियों को लागू कर सकता है, यह सुनिश्चित करते हुए कि उत्पाद की उपलब्धता
                प्लेटफ़ॉर्म पर सटीक रूप से दिखाई देती है। इससे ग्राहकों के अधिक बिकने या
                निराश होने की संभावना कम हो जाती है। </label>

            <h5 class="mt-3" >बिजनेस इनसाइट्स के लिए डेटा एनालिटिक्स </h5>
            <label for="" class="mt-1" >जी-स्टोर ग्राहक व्यवहार, प्राथमिकताओं
                और खरीदारी पैटर्न में अंतर्दृष्टि इकट्ठा करने के लिए डेटा एनालिटिक्स टूल का
                उपयोग कर सकता है। यह डेटा सूचित व्यावसायिक निर्णय लेने और ऑनलाइन शॉपिंग
                अनुभव को अनुकूलित करने के लिए अमूल्य हो सकता है।
            </label>

            <h5 class="mt-3" >विपणन के अवसर </h5>
            <label for="" class="mt-1" >जी-स्टोर ग्राहकों को आकर्षित करने और
                बनाए रखने के लिए सोशल मीडिया अभियान, ईमेल मार्केटिंग और खोज इंजन अनुकूलन
                सहित विभिन्न ऑनलाइन मार्केटिंग रणनीतियों को आसानी से लागू कर सकता है।
            </label>
        </div>
        <div class="col-md-12 mt-3" (mouseover)="showpayment(true,'5')"
            (mouseout)="showpayment(false,'5')" id="45">
           
            <h2 >शुरुआत कैसे करें: </h2>
            <label for="" class="mt-1" >
                इन अविश्वसनीय सुविधाओं तक पहुँच प्राप्त करना सरल है:

            </label>

            <h5 class="mt-4" >चरण 1: पे जी ऐप पर साइन इन करें</h5>
            <label for="" >

                अपने क्रेडेंशियल्स दर्ज करके अपने व्यापारी खाते में साइन इन करें। यदि आप एक
                नए उपयोगकर्ता हैं, तो एक नए खाते के लिए साइन अप करें और अपने क्रेडेंशियल्स
                के साथ लॉग इन करें। आप अपने डिवाइस के ऐप स्टोर से हमारे पे जी मोबाइल ऐप
                डाउनलोड कर सकते हैं।
            </label>
            <div class="row">
                <div class="col-md-12 mt-4">
                    <img src="./assets/g-store1.png" width="50%" height="95%" alt="">
                </div>

            </div>

            <h5 class="mt-4" >चरण 2: अपनी प्रोफ़ाइल बनाएं </h5>
            <label for="" >
                ऐप के भीतर अपने खाते में साइन अप करें या लॉग इन करें। अपना व्यवसाय विवरण
                भरें, अपना लोगो अपलोड करें और अपनी प्रोफ़ाइल कस्टमाइज़ करें। </label>
            <div class="row">
                <div class="col-md-12 mt-2">
                    <img src="./assets/g-store2.png" width="50%" height="95%" alt="">
                </div>
                <div class="col-md-12 mt-2">
                    <img src="./assets/g-store3.png" width="50%" height="95%" alt="">
                </div>
                <div class="col-md-12 mt-2">
                    <img src="./assets/g-store4.png" width="50%" height="95%" alt="">
                </div>
                <div class="col-md-12 mt-2">
                    <img src="./assets/g-store5.png" width="50%" height="95%" alt="">
                </div>
                <div class="col-md-12 mt-2">
                    <img src="./assets/g-store6.png" width="50%" height="95%" alt="">
                </div>

            </div>

            <h5 class="mt-4" >चरण 3: इन्वेंट्री जोड़ें </h5>
            <label for="" >आप हमारी जी-स्टोर लाइब्रेरी का उपयोग करके इन्वेंट्री
                को सहजता से एकीकृत कर सकते हैं, जिसमें 1.5 करोड़ उत्पाद शामिल हैं। वैकल्पिक
                रूप से, आप अपने आइटमों को अपने स्टोर में जोड़ने के लिए उनके बारकोड को स्कैन
                करना चुन सकते हैं। तीसरे विकल्प में अपने उत्पादों को मैन्युअल रूप से जोड़ना
                शामिल है। </label>
            <div class="row">
                <div class="col-md-12 mt-4">
                    <img src="./assets/g-store7.png" width="50%" height="95%" alt="">
                </div>

            </div>

            <h5 class="mt-4" >चरण 4: अन्वेषण करें और सक्रिय करें </h5>
            <label for="" >

                सब कुछ सक्रिय होने पर, आप पुरस्कार प्राप्त करने के लिए तैयार हैं। आपका
                ऑनलाइन शॉपिंग स्टोर पहले से कहीं अधिक आकर्षक, ग्राहक-अनुकूल और गतिशील बन
                जाएगा।एक बार जब आपकी प्रोफ़ाइल सेट हो जाए, तो 'जी-स्टोर' अनुभाग पर जाएँ।
                वहां, आपको अपना व्यवसाय कार्ड, टिकट, कूपन, प्रोफ़ाइल क्यूआर कोड और भुगतान
                क्यूआर कोड सक्रिय करने के विकल्प मिलेंगे।
            </label>
            <div class="row">
                <div class="col-md-12 mt-4">
                    <img src="./assets/g-store8.png" width="50%" height="95%" alt="">
                </div>

            </div>
            <h5 class="mt-4" >चरण 5: लाभों का आनंद लेना शुरू करें </h5>
            <label for="" >

                सब कुछ सक्रिय होने पर, आप पुरस्कार प्राप्त करने के लिए तैयार हैं। आपका
                ऑनलाइन शॉपिंग स्टोर पहले से कहीं अधिक आकर्षक, ग्राहक-अनुकूल और गतिशील बन
                जाएगा।
            </label>
            <label for="" class="col-md-12 mt-4" >

                इस डिजिटल युग में, खड़े रहना और अपने ग्राहकों को सुविधा प्रदान करना सर्वोपरि
                है। पे जी ऐप पर अपनी प्रोफ़ाइल बनाकर, आप इन लक्ष्यों को प्राप्त करने की दिशा
                में एक महत्वपूर्ण कदम उठा रहे हैं।
            </label>

        </div>
    </div>
</div>
</div>
<div class="col-md-4  hide-tbl content2  ">
<div class="card crd p-4">
    <div class="row">
        <div class="col-md-12">
            <h5 >
                विषयसूची:
            </h5>
        </div>
        <!-- <div class="col-md-12 mt-2">
           <a href="#41">  <div class="row">
                <div class="col-md-2"> <img src="./assets/video.svg" class="tab-icon intro"
                        alt=""> &nbsp;</div>
                <div class="col-md-10">
                    <span style="cursor: pointer;" class="videoHover"
                        [ngClass]="{'video':colors=='1'}" (click)="color('1')">
                        Introduction to G-Store </span>
                </div>
            </div></a>
        </div> -->
        <div class="col-md-12 mt-2">
            <a href="#42">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='2'}" (click)="color('2')"
                            >
                            जी-स्टोर का परिचय </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-0">
            <a href="#43">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">

                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='3'}" (click)="color('3')"
                            >जी-स्टोर की विशेषताएं </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-0">
            <a href="#44">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">

                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='4'}" (click)="color('4')"
                            >
                            जी-स्टोर का उपयोग करने के लाभ </span>
                    </div>
                </div>
            </a>
        </div>
        <div class="col-md-12 mt-0">
            <a href="#45">
                <div class="row">
                    <div class="col-md-2"> <img   src="./assets/edit.svg" class="tab-icon intro"
                            alt="">
                        &nbsp;</div>
                    <div class="col-md-10">
                        <span style="cursor: pointer;" class="textHover"
                            [ngClass]="{'text':colors=='5'}" (click)="color('5')"
                            >शुरुआत कैसे करें? </span>
                    </div>
                </div>
            </a>
        </div>




    </div>
</div>
</div>
<div class="col-md-9 hide ft-9">
    <hr>
    <div class=" row crd">
        <div class="col-md-8">
         
            <a [routerLink]="['/create-link']">   <button class="btn btn-color" (click)="menues('Create Payment')" > <img
                    src="./assets/Arrow 3.svg" alt="">&nbsp;&nbsp;क्रिएट पेमेंट लिंक
            </button></a>
        </div>
        <div class="col-md-4   ">
         
            <a [routerLink]="['/pay-button']">  <button class="btn btn-color" (click)="menues('Pay Button')" >पे बटन
                &nbsp;<img src="./assets/Arrow 2 1.svg" alt=""></button></a>
        </div>
    </div>
</div>
</div>